import styled from 'styled-components';
import {OverflowProperty} from "../../../../../common/types/css";
import {CssRule} from "../../../../themes/architecture/css-helpers/css-rule";

interface IDialogConsumerContentProps {
    noPadding?: boolean;
    disableFullscreenMobile?: boolean;
    overflow?: OverflowProperty
    useAutoHeight?: boolean;
}

export const DialogConsumerContentDefaultBox = styled.div<IDialogConsumerContentProps>`
    flex-grow: 1;
    padding: ${({noPadding}) => noPadding ? "0" : "2rem 2rem 3rem"};
    margin: 0;
    background-color: ${({theme}) => theme.colors.backgroundMiddleDark };
    overflow: ${props => props.overflow ?? "auto"};

    @media ${({theme}) => theme.mediaQuery.lAndBelow} {
        padding: ${(props) => props.disableFullscreenMobile ? (props.noPadding ? "0" : "2rem 2rem 3rem") : "0"};
        height:  ${(props) => props.disableFullscreenMobile || props.useAutoHeight ? "auto" : "100%"}
        
    }

  ${CssRule.For.mobile.landscape.build()} & {
    padding: ${(props) => props.disableFullscreenMobile ? (props.noPadding ? "0" : "0.5rem") : "0"};
  }
  
    border-radius: 10px;
`;
